module.exports = __webpack_public_path__ + "img/company-update.c43e3d24.webp";